import {
  GET_LABTESTSAMPLE_FAIL,
  GET_LABTESTSAMPLE_SUCCESS,
  GET_LABTESTSAMPLES_FAIL,
  GET_LABTESTSAMPLES_SUCCESS,
  ADD_LABTESTSAMPLE_SUCCESS,
  ADD_LABTESTSAMPLE_FAIL,
  UPDATE_LABTESTSAMPLE_SUCCESS,
  UPDATE_LABTESTSAMPLE_FAIL,
  DELETE_LABTESTSAMPLE_SUCCESS,
  DELETE_LABTESTSAMPLE_FAIL,  
  SET_STATE_LABTESTSAMPLE
} from "./actionTypes";

const INIT_STATE = {
  labTestSamples: [],
  labTestSample: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labTestSamples = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABTESTSAMPLES_SUCCESS:
      return {
        ...state,
        labTestSamples: action.payload.labTestSamples,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABTESTSAMPLE:
      return { ...state, loading: action.payload }

    case GET_LABTESTSAMPLES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABTESTSAMPLE_SUCCESS:
      return {
        ...state,
        labTestSamples: [...state.labTestSamples, action.payload],
      };

    case ADD_LABTESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABTESTSAMPLE_SUCCESS:
      return {
        ...state,
        labTestSamples: state.labTestSamples.map(labTestSample =>
          labTestSample.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labTestSample }
            : labTestSample
        ),
      };

    case UPDATE_LABTESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABTESTSAMPLE_SUCCESS:
      return {
        ...state,
        labTestSamples: state.labTestSamples.filter(
          labTestSample => labTestSample.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABTESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABTESTSAMPLE_SUCCESS:
      return {
        ...state,
        labTestSample: action.payload,
      };

    case GET_LABTESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labTestSamples;
